import { HStack, Td, Text, Tr } from '@chakra-ui/react';
import { R$ } from 'shared/helpers/currency';
import { IProduct, Product } from 'shared/models/product';
import EditServicePriceButton from '../atoms/EditServicePriceButton';
import DeleteServiceButton from '../atoms/DeleteServiceButton';

interface CollumnTextTheme {
  w: string;
  h: string;
  bg: string;
  color: string;
}
interface ServiceTableLineProps {
  loading?: boolean;
  service?: Product;
}

const ServiceTableLine = ({ loading, service }: ServiceTableLineProps) => {
  if (!service) {
    service = new Product({} as IProduct);
  }

  let collumnTextTheme: CollumnTextTheme = {
    w: 'auto',
    h: 'auto',
    bg: 'transparent',
    color: '',
  };
  if (loading) {
    collumnTextTheme = {
      w: '80px',
      h: '20px',
      bg: 'yGray.50',
      color: 'transparent',
    };
  }

  return (
    <Tr>
      <Td>
        <Text
          w={collumnTextTheme.w}
          h={collumnTextTheme.h}
          bg={collumnTextTheme.bg}
          borderRadius="5px"
          color={collumnTextTheme.color}
        >
          {service.plan?.name}
        </Text>
      </Td>
      <Td>
        <HStack spacing={1}>
          <Text
            w={collumnTextTheme.w}
            h={collumnTextTheme.h}
            bg={collumnTextTheme.bg}
            borderRadius="5px"
            color={collumnTextTheme.color}
          >
            {service.priceString}
          </Text>
          <EditServicePriceButton loading={loading} service={service} />
        </HStack>
      </Td>
      <Td>
        <Text
          w={collumnTextTheme.w}
          h={collumnTextTheme.h}
          bg={collumnTextTheme.bg}
          borderRadius="5px"
          color={collumnTextTheme.color}
        >
          {service.discount_value ? R$(service.discount_value) : '-'}
        </Text>
      </Td>
      <Td>
        <Text
          w={collumnTextTheme.w}
          h={collumnTextTheme.h}
          bg={collumnTextTheme.bg}
          borderRadius="5px"
          color={collumnTextTheme.color}
        >
          {service.discount?.cycles ? service.discount?.cycles : '-'}
        </Text>
      </Td>
      <Td>
        <Text
          w={collumnTextTheme.w}
          h={collumnTextTheme.h}
          bg={collumnTextTheme.bg}
          borderRadius="5px"
          color={collumnTextTheme.color}
        >
          {service.created_at ? service.created_at.format('DD/MM/YYYY') : ''}
        </Text>
      </Td>
      <Td w="10px">
        <DeleteServiceButton
          loading={loading}
          service={service}
        ></DeleteServiceButton>
      </Td>
    </Tr>
  );
};
export default ServiceTableLine;
